import { render, staticRenderFns } from "./instructionsPdfOnlinexinyou.vue?vue&type=template&id=11f872af&scoped=true&"
import script from "./instructionsPdfOnlinexinyou.vue?vue&type=script&lang=js&"
export * from "./instructionsPdfOnlinexinyou.vue?vue&type=script&lang=js&"
import style0 from "./instructionsPdfOnlinexinyou.vue?vue&type=style&index=0&id=11f872af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f872af",
  null
  
)

export default component.exports